import * as React from "react";

// because function type signatures are awkward
type Counter = () => number;

// Inside a class this is a little awkward, and probably better
// done as an instance var, but... here's the magic...
function getCounter(): Counter {
  let count = 0;
  return () => ++count;
}

enum Status {
  UNDONE = "I ain't done nothin' yet.",
  DONE = "I done the thing, Boss.",
  ALREADY = "Already done it. Not doin' it again.",
};

interface ClosureState {
  counter: Counter,
  label: Status,
}

export class Closure
    extends React.Component<{}, ClosureState> {

  constructor(props: object) {
    super(props);

    this.state = {
      counter: getCounter(),
      label: Status.UNDONE,
    };
  }

  doThingOnce: () => void = () => this.setState({
    label: (this.state.counter() <= 1) ? Status.DONE : Status.ALREADY
  });

  reset: () => void = () => this.setState({
    counter: getCounter(),
    label: Status.UNDONE,
  });

  render() {
    return <label>
        <button onClick={this.reset}>Reset</button>
        <button onClick={this.doThingOnce}>Do the thing</button>
        &nbsp;{this.state.label}
      </label>;
  }
}
